import { Box } from '@mui/material';

function Logo() {
  return (
    <Box
      component="img"
      src="/assets/images/call-summarization-logo.png"
      alt="logo"
      width={185}
    />
  );
}

export default Logo;
